import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Button, FlexBox, Text } from '@dixa/lib-shared-habla';
import { conversationsApi, } from 'apis/conversations';
import { IfAgentHasRole } from 'components/shared/agentRole';
import { useAppNavigate } from 'utils/url/useAppNavigate';
import { LogEntry } from './logEntry';
import { RoutedThroughAnnouncement, RoutedThroughAutoReply, RoutedThroughBusinessHours, RoutedThroughCallRecording, RoutedThroughClose, RoutedThroughDialInput, RoutedThroughFilter, RoutedThroughForward, RoutedThroughIntegration, RoutedThroughIVRMenu, RoutedThroughLocation, RoutedThroughMessengerInput, RoutedThroughMessengerMenu, RoutedThroughQueue, RoutedThroughTags, RoutedThroughVoicemail, } from './routedThroughNodes';
function getRoutedNode(node) {
    switch (node.node_type) {
        case 'externaldatarouting':
            return _jsx(RoutedThroughFilter, { node: node });
        case 'phonenumber':
            return _jsx(RoutedThroughLocation, { node: node });
        case 'ivrmenu':
            return _jsx(RoutedThroughIVRMenu, { node: node });
        case 'businesshours':
            return _jsx(RoutedThroughBusinessHours, { node: node });
        case 'messengermenu':
            return _jsx(RoutedThroughMessengerMenu, { node: node });
        case 'queue':
            return _jsx(RoutedThroughQueue, { node: node });
        case 'forward':
            return _jsx(RoutedThroughForward, { node: node });
        case 'voicemail':
            return _jsx(RoutedThroughVoicemail, { node: node });
        case 'fetchexternaldata':
            return _jsx(RoutedThroughIntegration, { node: node });
        case 'callrecording':
            return _jsx(RoutedThroughCallRecording, { node: node });
        case 'autoreply':
            return _jsx(RoutedThroughAutoReply, { node: node });
        case 'tags':
            return _jsx(RoutedThroughTags, { node: node });
        case 'externaldataphoneinput':
            return _jsx(RoutedThroughDialInput, { node: node });
        case 'messengerinputfield':
            return _jsx(RoutedThroughMessengerInput, { node: node });
        case 'announcement':
            return _jsx(RoutedThroughAnnouncement, { node: node });
        case 'close':
            return _jsx(RoutedThroughClose, { node: node });
        default:
            return 'Unrecognized action';
    }
}
const channelPathMap = {
    phone: 'phone',
    email: 'email',
    messenger: 'dixa-messenger',
};
export const RoutedThroughFlow = ({ entry }) => {
    const navigate = useAppNavigate();
    const { data } = conversationsApi.useReadConversationFlowActivitiesQuery({
        csid: entry.csid,
    });
    const handleGoToFlow = () => {
        navigate({
            path: '/settings/:channel/flow/:flowId',
            params: {
                path: {
                    channel: channelPathMap[entry.channel],
                    flowId: entry.flow_id,
                },
            },
        });
    };
    return (_jsx(LogEntry, Object.assign({ entry: entry, icon: "route", text: `Routed through ${entry.channel} flow ${entry.flow_name} ${['phone', 'email'].includes(entry.channel)
            ? `for ${entry.location}`
            : ''}`, isExpandable: true }, { children: _jsxs(FlexBox, Object.assign({ padding: "0 0 0 300", margin: "0 0 0 500", gap: "200", flexDirection: "column" }, { children: [data === null || data === void 0 ? void 0 : data.data.flow_activities.map((node, index) => (_jsx(Text.Paragraph, Object.assign({ variant: "2", subdued: true }, { children: getRoutedNode(node) }), index))), _jsx(IfAgentHasRole, Object.assign({ role: "systemadmin" }, { children: _jsx(FlexBox, Object.assign({ margin: "300 0" }, { children: _jsx(Button, Object.assign({ variant: "secondary", onClick: handleGoToFlow }, { children: "Go to flow" })) })) }))] })) })));
};
